export const SET_FEEDBACK_QUESTION = 'SET_FEEDBACK_QUESTION'
export const SET_FEEDBACK_STATE_REQUEST = 'SET_FEEDBACK_STATE_REQUEST'
export const SET_FEEDBACK_STATE_SUCCESS = 'SET_FEEDBACK_STATE_SUCCESS'
export const SET_FEEDBACK_STATE_FAILURE = 'SET_FEEDBACK_STATE_FAILURE'
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS'
